<template>
    <div style="opacity: 0; width: 1px; height: 1px" class="order-block">
        <div class="order-block__title"><span>Способ доставки:</span></div>
        <div class="order-block__content m-t-30">
            <fieldset class="form-group fieldset_vertical">
                <div v-for="deliveryType in dataList" :key="+deliveryType.ID" class="row">
                    <div class="col-4">
                        <label class="custom-control custom-radio">
                            <input :value="+deliveryType.ID" v-model="value" :name="inputName" type="radio"
                                   class="custom-control-input">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{deliveryType.NAME}}</span>
                        </label>
                    </div>
                    <div v-if="deliveryType['PERIOD_TEXT']" class="col-3"><span class="color-grey">Срок: {{deliveryType['PERIOD_TEXT']}}</span>
                    </div>
                    <div v-if="deliveryType['PRICE']" class="col-3"><span class="color-grey">Стоимость: {{deliveryType['PRICE_FORMATED']}}</span>
                    </div>
                    <div v-if="deliveryType['CALCULATE_ERRORS']" class="col-3"><span class="color-red" v-html="deliveryType['CALCULATE_ERRORS']"></span>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'delivery-select',
    props: {
      dataList: {
        type: [Object, Array],
        default () {
          return {}
        }
      },
      defaultValue: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        inputName: 'deliveryType',
        value: this.defaultValue
      }
    },
    watch: {
      value: function (value) {
        this.$emit('select', value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/DeliverySelect.vue